/* PEUM — theme.js : minimal interactivity */
(function () {
  "use strict";

  // Desktop mega-menu is CSS-driven (:hover / :focus-within) — no JS needed.

  // Cart page — update quantities and remove lines without a page reload.
  // Falls back to the plain form POST when JS is unavailable.
  (function () {
    var page = document.querySelector("[data-cart-page]");
    if (!page) return;
    var sectionId = page.getAttribute("data-section-id");

    function setBadge(count) {
      var badge = document.querySelector("[data-cart-count]");
      if (!badge) return;
      badge.textContent = count;
      if (count > 0) badge.removeAttribute("hidden");
      else badge.setAttribute("hidden", "");
    }
    function rerender() {
      fetch(window.location.pathname + "?section_id=" + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-cart-page]");
          if (fresh) {
            page.innerHTML = fresh.innerHTML;
            bind();
          }
        })
        .catch(function () { window.location.reload(); });
    }
    function change(key, quantity) {
      page.classList.add("is-busy");
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setBadge(cart.item_count);
          rerender();
        })
        .catch(function () { window.location.reload(); })
        .then(function () { page.classList.remove("is-busy"); });
    }
    function bind() {
      page.querySelectorAll("[data-cart-qty]").forEach(function (input) {
        input.addEventListener("change", function () {
          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 0) qty = 0;
          change(input.getAttribute("data-line-key"), qty);
        });
      });
      page.querySelectorAll("[data-cart-remove]").forEach(function (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          change(link.getAttribute("data-line-key"), 0);
        });
      });

      // Bojagi wrapping add-on (state is server-rendered; rerender() refreshes it)
      var wrapBox = page.querySelector("[data-wrap-upsell]");
      if (wrapBox) {
        var wrapId = parseInt(wrapBox.getAttribute("data-wrap-id"), 10);
        var wrapKey = wrapBox.getAttribute("data-wrap-line");
        var toggle = wrapBox.querySelector("[data-wrap-toggle]");
        function post(url, payload) {
          page.classList.add("is-busy");
          return fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify(payload)
          })
            .then(function (r) { return r.json(); })
            .then(function (cart) { if (cart && typeof cart.item_count === "number") setBadge(cart.item_count); rerender(); })
            .catch(function () { window.location.reload(); })
            .then(function () { page.classList.remove("is-busy"); });
        }
        var wrapQty = parseInt(wrapBox.getAttribute("data-wrap-qty"), 10) || 0;
        if (toggle) {
          toggle.addEventListener("change", function () {
            if (toggle.checked) {
              page.classList.add("is-busy");
              fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ id: wrapId, quantity: 1 })
              })
                .then(function () { return fetch("/cart.js", { headers: { Accept: "application/json" } }); })
                .then(function (r) { return r.json(); })
                .then(function (cart) { setBadge(cart.item_count); rerender(); })
                .catch(function () { window.location.reload(); })
                .then(function () { page.classList.remove("is-busy"); });
            } else if (wrapKey) {
              post("/cart/change.js", { id: wrapKey, quantity: 0 });
            }
          });
        }
        // Wrap quantity stepper
        var wrapInc = wrapBox.querySelector("[data-wrap-inc]");
        var wrapDec = wrapBox.querySelector("[data-wrap-dec]");
        if (wrapInc) wrapInc.addEventListener("click", function () {
          if (wrapKey) post("/cart/change.js", { id: wrapKey, quantity: wrapQty + 1 });
        });
        if (wrapDec) wrapDec.addEventListener("click", function () {
          if (wrapKey) post("/cart/change.js", { id: wrapKey, quantity: wrapQty - 1 });
        });
      }
    }
    bind();
  })();

  // Mobile drawer menu
  var drawer = document.querySelector("[data-drawer]");
  var burger = document.querySelector("[data-drawer-open]");
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
    if (burger) burger.setAttribute("aria-expanded", "true");
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
    if (burger) burger.setAttribute("aria-expanded", "false");
    // Reset the drill-down to the top level after the slide-out finishes
    setTimeout(function () {
      menuStack.length = 0;
      drawer.querySelectorAll("[data-menu-panel].is-open").forEach(function (p) {
        p.classList.remove("is-open");
      });
    }, 350);
  }
  document.querySelectorAll("[data-drawer-open]").forEach(function (b) {
    b.addEventListener("click", openDrawer);
  });
  document.querySelectorAll("[data-drawer-close]").forEach(function (b) {
    b.addEventListener("click", closeDrawer);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  // Drawer drill-down panels — parents slide a sub-panel in from the
  // right; the back button pops it off the stack.
  var menuStack = [];
  if (drawer) {
    drawer.querySelectorAll("[data-menu-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var target = document.getElementById(btn.getAttribute("data-menu-open"));
        if (!target) return;
        target.classList.add("is-open");
        target.scrollTop = 0;
        menuStack.push(target);
      });
    });
    drawer.querySelectorAll("[data-menu-back]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var top = menuStack.pop();
        if (top) top.classList.remove("is-open");
      });
    });
  }

  // Product image gallery
  var galleryMain = document.querySelector("[data-gallery-main]");
  if (galleryMain) {
    var mainImg = galleryMain.querySelector("img");
    document.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute("data-full");
        mainImg.removeAttribute("srcset");
        document.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
          t.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
      });
    });
  }

  // Product variant picker — keeps the added variant, price, availability
  // and image in sync with the selected options.
  (function () {
    var root = document.querySelector("[data-product-root]");
    if (!root) return;
    var dataEl = root.querySelector("[data-variants]");
    var selects = root.querySelectorAll("[data-option-select]");
    if (!dataEl || !selects.length) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var currency = root.getAttribute("data-currency") || "AUD";
    var idInput = root.querySelector("[data-variant-id]");
    var addBtn = root.querySelector("[data-add-btn]");
    var priceEl = root.querySelector("[data-price]");
    var mainImg = document.querySelector("[data-gallery-main] img");

    function money(cents) {
      try {
        return new Intl.NumberFormat(undefined, { style: "currency", currency: currency }).format(cents / 100);
      } catch (e) { return "$" + (cents / 100).toFixed(2); }
    }

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var hit = true;
        for (var j = 0; j < chosen.length; j++) {
          if (v.options[j] !== chosen[j]) { hit = false; break; }
        }
        if (hit) { match = v; break; }
      }

      if (!match) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute("data-unavailable-text") || "Unavailable";
        }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? addBtn.getAttribute("data-add-text")
          : addBtn.getAttribute("data-sold-text");
      }
      if (priceEl) {
        var html = "";
        var onSale = match.compare_at_price && match.compare_at_price > match.price;
        if (onSale) {
          html += '<s style="color:#9a9a94;margin-right:8px">' + money(match.compare_at_price) + "</s>";
        }
        html += money(match.price);
        if (onSale) {
          var pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
          html += '<span class="price__pct">&minus;' + pct + "%</span>";
        }
        priceEl.innerHTML = html;
      }
      if (mainImg && match.featured_image && match.featured_image.src) {
        mainImg.src = match.featured_image.src;
        mainImg.removeAttribute("srcset");
      }
    }

    Array.prototype.forEach.call(selects, function (s) {
      s.addEventListener("change", update);
    });

    // Option swatches drive the hidden selects, so the variant-matching
    // logic above stays the single source of truth.
    root.querySelectorAll("[data-option-group]").forEach(function (group) {
      var select = group.querySelector("[data-option-select]");
      var valueLabel = group.querySelector("[data-option-value-label]");
      group.querySelectorAll("[data-option-swatch]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          group.querySelectorAll("[data-option-swatch].is-active").forEach(function (b) { b.classList.remove("is-active"); });
          btn.classList.add("is-active");
          var value = btn.getAttribute("data-value");
          if (valueLabel) valueLabel.textContent = value;
          if (select) {
            select.value = value;
            select.dispatchEvent(new Event("change"));
          }
        });
      });
    });
  })();

  // Hero slideshow — crossfading colour stories. Auto-advances every 6s,
  // pauses on hover, respects reduced-motion. Dots jump directly.
  (function () {
    var hero = document.querySelector("[data-hero-slideshow]");
    if (!hero) return;
    var slides = hero.querySelectorAll("[data-hero-slide]");
    var dots = hero.querySelectorAll("[data-hero-dot]");
    var idx = 0;
    var timer = null;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle("is-active", j === idx); });
      dots.forEach(function (d, j) { d.classList.toggle("is-active", j === idx); });
    }
    var duration = (parseInt(hero.getAttribute("data-duration"), 10) || 5) * 1000;
    function start() {
      if (slides.length < 2) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      timer = setInterval(function () { go(idx + 1); }, duration);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, i) {
      d.addEventListener("click", function () { stop(); go(i); start(); });
    });
    hero.addEventListener("mouseenter", stop);
    hero.addEventListener("mouseleave", start);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop(); else if (!timer) start();
    });
    start();

    // Moment line — the visitor's local time, Seoul when unreadable
    var moment = hero.querySelector("[data-hero-moment]");
    if (moment) {
      var tz = null;
      try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch (e) {}
      var now = new Date();
      var hour, minutes, city;
      if (tz) {
        hour = now.getHours();
        minutes = now.getMinutes();
        city = tz.indexOf("/") > -1 ? tz.split("/").pop().replace(/_/g, " ") : tz;
      } else {
        hour = (now.getUTCHours() + 9) % 24; // Seoul, no DST
        minutes = now.getUTCMinutes();
        city = "Seoul";
      }
      var h12 = hour % 12 || 12;
      var timeStr = h12 + ":" + (minutes < 10 ? "0" : "") + minutes + (hour < 12 ? "am" : "pm");
      var tpl = moment.getAttribute("data-template") || "";
      moment.textContent = tpl.replace("{time}", timeStr).replace("{city}", city);
      moment.removeAttribute("hidden");
    }
  })();

  // 품 film — crossfade scenes as the visitor scrolls through the steps,
  // with a slow drift on the glyph tied to overall progress.
  (function () {
    var root = document.querySelector("[data-pum]");
    if (!root) return;
    var scenes = root.querySelectorAll("[data-pum-scene]");
    var steps = root.querySelectorAll("[data-pum-step]");
    if (!scenes.length || !("IntersectionObserver" in window)) return;

    function activate(i) {
      scenes.forEach(function (s, idx) { s.classList.toggle("is-active", idx === i); });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) activate(parseInt(e.target.getAttribute("data-index"), 10));
      });
    }, { rootMargin: "-45% 0px -45% 0px" });
    steps.forEach(function (s) { io.observe(s); });

    // Once the film has fully played, collapse the walkthrough to a single
    // static screen so scrolling back up is a normal scroll, not a replay.
    // The scroll position is compensated so nothing visibly jumps.
    var track = root.querySelector("[data-pum-track]");
    if (track) {
      var onScroll = function () {
        var r = track.getBoundingClientRect();
        if (r.bottom <= window.innerHeight + 2) {
          window.removeEventListener("scroll", onScroll);
          io.disconnect();
          activate(scenes.length - 1);
          var before = track.offsetHeight;
          root.classList.add("is-done");
          var after = track.offsetHeight;
          // The compensation must be a hard jump — html has
          // scroll-behavior:smooth, which would animate it as a visible
          // fly-down-and-back glide.
          var html = document.documentElement;
          var prevBehavior = html.style.scrollBehavior;
          html.style.scrollBehavior = "auto";
          window.scrollBy(0, after - before);
          html.style.scrollBehavior = prevBehavior;
        }
      };
      window.addEventListener("scroll", onScroll, { passive: true });
    }

    // Reveal copy fades in every time the panel scrolls into view
    var reveal = root.querySelector(".pum__reveal");
    if (reveal) {
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          reveal.classList.toggle("is-inview", e.isIntersecting);
        });
      }, { threshold: 0.3 });
      rio.observe(reveal);
    }
  })();

  // Related products — fetched from Shopify's Recommendations API
  (function () {
    var host = document.querySelector("[data-product-recs]");
    if (!host) return;
    var url = host.getAttribute("data-url");
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-product-recs]");
        if (fresh) host.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  })();

  // Collection sort — submit on change (form still works without JS)
  document.querySelectorAll("[data-sort-select]").forEach(function (sel) {
    sel.addEventListener("change", function () {
      var form = sel.closest("form");
      if (form) form.submit();
    });
  });

  // Collection filters — checkboxes apply on change; open dropdowns close
  // when clicking elsewhere. Price fields use their Apply button instead.
  (function () {
    var facetsForm = document.querySelector("[data-facets]");
    if (!facetsForm) return;
    facetsForm.querySelectorAll(".facet__option input[type=checkbox]").forEach(function (cb) {
      cb.addEventListener("change", function () { facetsForm.submit(); });
    });
    document.addEventListener("click", function (e) {
      document.querySelectorAll("[data-facet][open]").forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute("open");
      });
    });
  })();

  // Thumbnail strip: show the arrows/fades only when images are cut off,
  // and let the arrows page through them.
  (function () {
    var col = document.querySelector("[data-thumbcol]");
    if (!col) return;
    var strip = col.querySelector("[data-thumbs]");
    if (!strip) return;
    var prev = col.querySelector("[data-thumbs-prev]");
    var next = col.querySelector("[data-thumbs-next]");
    var horizontal = function () { return window.matchMedia("(max-width: 900px)").matches; };

    function step() {
      var t = strip.querySelector(".product__thumb");
      if (!t) return 100;
      var r = t.getBoundingClientRect();
      return (horizontal() ? r.width : r.height) + 10;
    }
    function update() {
      var pos, size, total;
      if (horizontal()) {
        pos = strip.scrollLeft; size = strip.clientWidth; total = strip.scrollWidth;
      } else {
        pos = strip.scrollTop; size = strip.clientHeight; total = strip.scrollHeight;
      }
      var scrollable = total > size + 1;
      col.classList.toggle("can-up", scrollable && pos > 1);
      col.classList.toggle("can-down", scrollable && pos + size < total - 1);
    }
    function scrollBy(dir) {
      var by = step() * 2 * dir;
      if (horizontal()) strip.scrollBy({ left: by, behavior: "smooth" });
      else strip.scrollBy({ top: by, behavior: "smooth" });
    }

    if (prev) prev.addEventListener("click", function () { scrollBy(-1); });
    if (next) next.addEventListener("click", function () { scrollBy(1); });
    strip.addEventListener("scroll", update);
    window.addEventListener("resize", update);
    window.addEventListener("load", update);
    update();
  })();

  // Share button — uses the OS share sheet (native apps) where available,
  // and falls back to copying the link.
  document.querySelectorAll("[data-share]").forEach(function (btn) {
    var label = btn.querySelector("[data-share-label]");
    var original = label ? label.textContent : "";
    var url = btn.getAttribute("data-url");

    function confirmCopied() {
      if (!label) return;
      label.textContent = btn.getAttribute("data-copied-text") || "Link copied";
      setTimeout(function () { label.textContent = original; }, 2000);
    }
    function copyFallback() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(confirmCopied, function () {});
        return;
      }
      var ta = document.createElement("textarea");
      ta.value = url;
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); confirmCopied(); } catch (e) {}
      document.body.removeChild(ta);
    }

    btn.addEventListener("click", function () {
      if (navigator.share) {
        // Blocked contexts (e.g. the theme-editor iframe) reject the call —
        // fall back to copying. A user cancelling the share sheet (AbortError)
        // is not a failure, so don't copy over their cancel.
        navigator.share({ title: btn.getAttribute("data-title"), url: url }).catch(function (err) {
          if (!err || err.name !== "AbortError") copyFallback();
        });
      } else {
        copyFallback();
      }
    });
  });

  // Ajax cart drawer
  (function () {
    var cartDrawer = document.querySelector("[data-cart-drawer]");
    if (!cartDrawer) return;
    var cartBody = cartDrawer.querySelector("[data-cart-body]");
    var cartFoot = cartDrawer.querySelector("[data-cart-foot]");
    var totalEl = cartDrawer.querySelector("[data-cart-total]");
    var badge = document.querySelector("[data-cart-count]");
    var wrapBox = cartDrawer.querySelector("[data-wrap-upsell]");
    var wrapToggle = wrapBox ? wrapBox.querySelector("[data-wrap-toggle]") : null;
    var wrapQtyUI = wrapBox ? wrapBox.querySelector("[data-wrap-qty-ui]") : null;
    var wrapCount = wrapBox ? wrapBox.querySelector("[data-wrap-count]") : null;
    var wrapId = wrapBox ? parseInt(wrapBox.getAttribute("data-wrap-id"), 10) : 0;
    var wrapLine = null;

    function money(cents, currency) {
      try {
        return new Intl.NumberFormat(undefined, { style: "currency", currency: currency || "AUD" }).format(cents / 100);
      } catch (e) { return "$" + (cents / 100).toFixed(2); }
    }
    function openCart() { cartDrawer.classList.add("is-open"); document.body.style.overflow = "hidden"; }
    function closeCart() { cartDrawer.classList.remove("is-open"); document.body.style.overflow = ""; }
    function updateBadge(count) {
      if (!badge) return;
      badge.textContent = count;
      if (count > 0) badge.removeAttribute("hidden"); else badge.setAttribute("hidden", "");
    }
    function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }

    function render(cart) {
      updateBadge(cart.item_count);
      if (!cart.items || cart.items.length === 0) {
        cartBody.innerHTML = '<p class="cartd__empty">' + esc(cartBody.getAttribute("data-empty") || "Your cart is empty.") + "</p>";
        if (cartFoot) cartFoot.hidden = true;
        return;
      }
      var html = "";
      cart.items.forEach(function (item) {
        html += '<div class="cartd__item" data-line-key="' + item.key + '">';
        html += '<div class="cartd__thumb">' + (item.image ? '<img src="' + item.image + '" alt="">' : "") + "</div>";
        html += "<div>";
        html += '<a class="cartd__name" href="' + item.url + '">' + esc(item.product_title) + "</a>";
        if (item.variant_title && item.variant_title !== "Default Title") {
          html += '<div class="cartd__variant">' + esc(item.variant_title) + "</div>";
        }
        if (item.properties) {
          Object.keys(item.properties).forEach(function (k) {
            if (item.properties[k]) html += '<div class="cartd__variant">' + esc(k) + ": " + esc(item.properties[k]) + "</div>";
          });
        }
        html += '<div class="cartd__qty">';
        html += '<button type="button" data-qty-dec aria-label="Decrease quantity">−</button>';
        html += "<span>" + item.quantity + "</span>";
        html += '<button type="button" data-qty-inc aria-label="Increase quantity">+</button>';
        html += "</div>";
        html += '<button type="button" class="cartd__remove" data-remove>Remove</button>';
        html += "</div>";
        html += '<div class="cartd__price">' + money(item.final_line_price, cart.currency) + "</div>";
        html += "</div>";
      });
      cartBody.innerHTML = html;
      if (totalEl) totalEl.textContent = money(cart.total_price, cart.currency);
      if (cartFoot) cartFoot.hidden = false;
      syncWrap(cart);
      bindLines(cart.currency);
    }

    // Keep the bojagi-wrapping checkbox/colour field in step with the cart.
    function syncWrap(cart) {
      if (!wrapBox) return;
      wrapLine = null;
      cart.items.forEach(function (item) { if (item.variant_id === wrapId) wrapLine = item; });
      if (wrapToggle) wrapToggle.checked = !!wrapLine;
      if (wrapQtyUI) wrapQtyUI.hidden = !wrapLine;
      if (wrapCount) wrapCount.textContent = wrapLine ? wrapLine.quantity : 0;
    }
    function refreshCart() {
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); return cart; });
    }
    if (wrapToggle) {
      wrapToggle.addEventListener("change", function () {
        wrapToggle.disabled = true;
        var done = function () { wrapToggle.removeAttribute("disabled"); };
        if (wrapToggle.checked) {
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: wrapId, quantity: 1 })
          }).then(refreshCart).then(done, done);
        } else if (wrapLine) {
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: wrapLine.key, quantity: 0 })
          }).then(function (r) { return r.json(); }).then(render).then(done, done);
        } else done();
      });
    }
    // Wrap quantity stepper
    function changeWrapQty(delta) {
      if (!wrapLine) return;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: wrapLine.key, quantity: wrapLine.quantity + delta })
      }).then(function (r) { return r.json(); }).then(render);
    }
    if (wrapBox) {
      var wrapInc = wrapBox.querySelector("[data-wrap-inc]");
      var wrapDec = wrapBox.querySelector("[data-wrap-dec]");
      if (wrapInc) wrapInc.addEventListener("click", function () { changeWrapQty(1); });
      if (wrapDec) wrapDec.addEventListener("click", function () { changeWrapQty(-1); });
    }

    function change(key, quantity) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(render);
    }
    function bindLines() {
      cartBody.querySelectorAll(".cartd__item").forEach(function (row) {
        var key = row.getAttribute("data-line-key");
        var q = parseInt(row.querySelector(".cartd__qty span").textContent, 10) || 1;
        var inc = row.querySelector("[data-qty-inc]");
        var dec = row.querySelector("[data-qty-dec]");
        var rm = row.querySelector("[data-remove]");
        if (inc) inc.addEventListener("click", function () { change(key, q + 1); });
        if (dec) dec.addEventListener("click", function () { change(key, q - 1); });
        if (rm) rm.addEventListener("click", function () { change(key, 0); });
      });
    }
    function fetchAndOpen() {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); openCart(); });
    }

    document.querySelectorAll("[data-cart-open]").forEach(function (el) {
      el.addEventListener("click", function (e) { e.preventDefault(); fetchAndOpen(); });
    });
    cartDrawer.querySelectorAll("[data-cart-close]").forEach(function (el) {
      el.addEventListener("click", closeCart);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

    var addForm = document.querySelector('form[action$="/cart/add"], form[action*="/cart/add"]');
    if (addForm) {
      addForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = addForm.querySelector('[name="add"]');
        if (btn) btn.setAttribute("disabled", "");
        fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(addForm) })
          .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
          .then(function () { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); })
          .then(function (cart) { render(cart); openCart(); })
          .catch(function () { addForm.submit(); })
          .then(function () { if (btn) btn.removeAttribute("disabled"); });
      });
    }

    // Card quick add + variant swatches. Delegated so cards injected
    // later (recommendations fetch) work without rebinding.
    document.addEventListener("click", function (e) {
      var swatch = e.target.closest("[data-swatch]");
      if (swatch) {
        e.preventDefault();
        var card = swatch.closest("[data-card]");
        if (!card) return;
        card.querySelectorAll("[data-swatch].is-active").forEach(function (s) { s.classList.remove("is-active"); });
        swatch.classList.add("is-active");

        var img = card.querySelector(".card__media img");
        var newSrc = swatch.getAttribute("data-image");
        if (img && newSrc) { img.removeAttribute("srcset"); img.src = newSrc; }

        var priceEl = card.querySelector("[data-card-price]");
        if (priceEl) {
          var compare = swatch.getAttribute("data-compare-formatted");
          priceEl.innerHTML = (compare ? "<s>" + compare + "</s> " : "") + swatch.getAttribute("data-price-formatted");
        }

        var add = card.querySelector("[data-quick-add]");
        if (add) {
          add.setAttribute("data-variant-id", swatch.getAttribute("data-variant-id"));
          var available = swatch.getAttribute("data-available") === "true";
          add.disabled = !available;
          add.textContent = available ? add.getAttribute("data-add-label") : add.getAttribute("data-sold-label");
        }
        return;
      }

      var quickAdd = e.target.closest("[data-quick-add]");
      if (!quickAdd || quickAdd.disabled) return;
      var variantId = parseInt(quickAdd.getAttribute("data-variant-id"), 10);
      if (!variantId) return;
      quickAdd.setAttribute("disabled", "");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); })
        .then(function (cart) { render(cart); openCart(); })
        .catch(function () {})
        .then(function () { quickAdd.removeAttribute("disabled"); });
    });
  })();

  // Scroll reveal — section heads fade up once as they enter; grids
  // stagger their children left-to-right. Skipped entirely for
  // reduced-motion visitors and browsers without IntersectionObserver.
  (function () {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!("IntersectionObserver" in window)) return;
    document.documentElement.classList.add("js-reveal");

    document.querySelectorAll(".section__head, .page-header, .split__media, .split__body, .saekdong")
      .forEach(function (el) { el.setAttribute("data-reveal", ""); });

    document.querySelectorAll(".grid-3, .grid-4, .values__grid, .scenes__grid")
      .forEach(function (group) {
        Array.prototype.forEach.call(group.children, function (child, i) {
          child.setAttribute("data-reveal", "");
          child.style.transitionDelay = Math.min(i * 80, 480) + "ms";
        });
      });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("is-revealed");
        io.unobserve(e.target);
        // Clear the stagger delay so later transitions (if any) are instant
        setTimeout(function () { e.target.style.transitionDelay = ""; }, 1400);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });

    document.querySelectorAll("[data-reveal]").forEach(function (el) {
      // Anything already in the first viewport shows immediately — the
      // reveal is for scrolling into sections, not a page-load curtain.
      if (el.getBoundingClientRect().top < window.innerHeight * 0.95) {
        el.classList.add("is-revealed");
      } else {
        io.observe(el);
      }
    });
  })();

  // Back to top — the norigae appears after a viewport of scrolling;
  // clicking gives a little downward tug, then glides the page up.
  (function () {
    var btt = document.querySelector("[data-back-to-top]");
    if (!btt) return;
    btt.removeAttribute("hidden");

    var ticking = false;
    function update() {
      ticking = false;
      btt.classList.toggle("is-in", window.scrollY > window.innerHeight * 1.1);
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();

    btt.addEventListener("click", function () {
      btt.classList.add("is-pulled");
      setTimeout(function () {
        btt.classList.remove("is-pulled");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 170);
    });
  })();
})();
